var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSiteMonitoringReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F7FA",
  d: "M8 6h42v26H8V6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F7FA",
  d: "M20 31h18v6H20v-6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 8h44v30H4V8Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#75899D",
  fillRule: "evenodd",
  d: "M47 9H5v28h42V9ZM4 8v30h44V8H4Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M7 11h38v24H7V11Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 37h22v6H15v-6Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#75899D",
  fillRule: "evenodd",
  d: "M36 38H16v4h20v-4Zm-21-1v6h22v-6H15ZM14 33V21h2v12h-2ZM29 33V16h2v17h-2ZM19 33V23h2v10h-2Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDC808",
  fillRule: "evenodd",
  d: "M24 33V19h2v14h-2ZM34 33V21h2v12h-2Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#75899D",
  d: "M13 41h26v3H13z"
})));
export { SvgSiteMonitoringReport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggNkg1MFYzMkg4VjZaIiBmaWxsPSIjRjZGN0ZBIi8+CjxwYXRoIGQ9Ik0yMCAzMUgzOFYzN0gyMFYzMVoiIGZpbGw9IiNGNkY3RkEiLz4KPHBhdGggZD0iTTQgOEg0OFYzOEg0VjhaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ3IDlINVYzN0g0N1Y5Wk00IDhWMzhINDhWOEg0WiIgZmlsbD0iIzc1ODk5RCIvPgo8cGF0aCBkPSJNNyAxMUg0NVYzNUg3VjExWiIgZmlsbD0iI0Y5RjlGOSIvPgo8cGF0aCBkPSJNMTUgMzdIMzdWNDNIMTVWMzdaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM2IDM4SDE2VjQySDM2VjM4Wk0xNSAzN1Y0M0gzN1YzN0gxNVoiIGZpbGw9IiM3NTg5OUQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAzMi45OTk5VjIxSDE2VjMyLjk5OTlIMTRaIiBmaWxsPSIjNzU4OTlEIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjkgMzNWMTZIMzFWMzNIMjlaIiBmaWxsPSIjNzU4OTlEIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkgMzNWMjNIMjFWMzNIMTlaIiBmaWxsPSIjNzU4OTlEIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQgMzMuMDAwMVYxOUgyNlYzMy4wMDAxSDI0WiIgZmlsbD0iI0ZEQzgwOCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM0IDMzVjIxSDM2VjMzSDM0WiIgZmlsbD0iI0ZEQzgwOCIvPgo8cmVjdCB4PSIxMyIgeT0iNDEiIHdpZHRoPSIyNiIgaGVpZ2h0PSIzIiBmaWxsPSIjNzU4OTlEIi8+Cjwvc3ZnPgo=";